import { cn } from "lib/cn";

export const Separator = ({ className }: { className?: string }) => (
    <div className={cn("h-[0.5px] bg-[#c8c8c8]", className)} />
);
